import { IGatsbyImageData } from "gatsby-plugin-image";
import * as React from "react";
import styled from "styled-components";

import { Container } from "@ui/Atoms/Grid";
import { Segment } from "@ui/Atoms";
import theme from "@ui/themes/default";
import { rem } from "@ui/helpers";

import { GatsbyImage } from "../../../components/GatsbyImage";

export interface StaffData {
  staff_image?: { gatsbyImageData: IGatsbyImageData };
}

interface Props {
  data: StaffData;
}

const Staff = ({ data }: Props): React.ReactElement => (
  <Background>
    <Container>
      <Segment isWithoutPadding>
        {data.staff_image && (
          <StaffImgWrapper>
            <GatsbyImage image={data.staff_image.gatsbyImageData} alt="maids" />
          </StaffImgWrapper>
        )}
      </Segment>
    </Container>
  </Background>
);

export { Staff };

const StaffImgWrapper = styled.div`
  max-width: ${rem(730)};
`;

const StaffImg = styled.img`
  max-width: 100%;
`;

const Background = styled.div`
  background: linear-gradient(
    to bottom,
    ${theme.palette.white} 70%,
    ${theme.palette.grey50} 0%
  );
`;
